export default {
  name: 'AcolorPicker',
  props: {
    value: null,
    size: { type: String, default: () => 'small' },
    default: { type: String, default: () => '#c58577' },
    predefine: {
      type: Array,
      default: () => [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#67c23a',
        '#13ce66',
        '#00ced1',
        '#409eff',
        '#1e90ff',
        '#c71585',
        '#c58577',
        '#d81e06',
        '#f4ea2a',
        '#1afa29',
        '#1296db',
        '#13227a',
        '#d4237a',
        '#ffffff',
        '#e6e6e6',
        '#dbdbdb',
        '#cdcdcd',
        '#bfbfbf',
        '#8a8a8a',
        '#707070',
        '#515151',
        '#2c2c2c',
      ]
    },
  },
  data() {
    return {
      theme: '',
    }
  },
  watch: {
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      this.theme = this.value;
    },
    input(a) {
      this.$emit('input', a ? a : '');
    },
    change(a) {
      this.$emit('input', a ? a : '');
      this.$emit('change', a ? a : '');
      this.$emit('choose', a ? a : '');
    },
    select(a) {
      this.$emit('input', a ? a : '');
      this.$emit('select', a ? a : '');
      this.$emit('choose', a ? a : '');
    },
  },
  render() {
    const { showAlpha = false, ...attrs } = this.$attrs;
    return (
      <el-color-picker
        size={this.size}
        v-model={this.theme}
        on-input={this.input}
        show-alpha={showAlpha}
        on-change={this.select}
        on-active-change={this.change}
        predefine={this.predefine}
        {...{ attrs }}
      />
    );
  }
}